import React from "react";

const AboutUs = () => {
  return (
    <section style={{ padding: "40px", backgroundColor: "#f9f9f9" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Who We Are – Your Trusted Real Estate Data Partner
        </h2>

        <p style={{ fontSize: "18px", lineHeight: "1.8", color: "#555" }}>
          We are a real estate data provider company based in NCR, specializing
          in property listings, price trends, and verified sales & rental
          information across Gurgaon, Noida, and South Delhi.
        </p>

        <p style={{ fontSize: "18px", lineHeight: "1.8", color: "#555" }}>
          Our mission is simple: Helping real estate professionals — brokers,
          and consultants — with real-time accurate data that drives results.
        </p>

        <ul
          style={{
            fontSize: "18px",
            lineHeight: "1.8",
            marginLeft: "20px",
            color: "#555",
          }}
        >
          <li>✅ No guesswork.</li>
          <li>✅ No outdated information.</li>
          <li>
            ✅ Just pure, actionable insights to help you close deals faster.
          </li>
        </ul>

        <p style={{ fontSize: "18px", lineHeight: "1.8", color: "#555" }}>
          With years of experience and a growing network, we serve brokers,
          agencies, developers, and investors who need reliable data to scale
          their business.
        </p>

        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            marginTop: "20px",
            color: "#222",
          }}
        >
          👉 Because in real estate, information is everything — and we make
          sure you always have the right one.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
